import {
  formPostApi,
  formPutApi,
  mutateApi,
  queryApi,
} from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"
import { camelCaseToSnakecase } from "src/utils/string_helpers"
import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

export const getContactBoats = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/contact_boats${qs}`)
}

export const getContactBoatsSelectableIds = (params = {}) => {
  const marinaSlug = getCurrentMarinaSlug()
  const qs = buildQueryString(params)
  return queryApi(`/manage/${marinaSlug}/contact_boats/selectable_ids${qs}`)
}

export const printContactBoats = async ({ ids, ...params }) => {
  const marinaSlug = getCurrentMarinaSlug()
  const response = await mutateApi({
    url: `/manage/${marinaSlug}/contact_boats/print`,
    method: "POST",
    data: { ids, ...params },
  })
  return response.data
}

export const createContact = async (
  marinaSlug,
  { contact, extraFields = [] }
) => {
  const query = extraFields.length ? `?include=${extraFields.join(",")}` : ""
  // Manage::ContactsController#create strong-params expects a flat body
  // (`params.permit :name, :email, :phone`). The existing
  // `createContactBoat` create-contact path POSTs flat too (see below).
  return mutateApi({
    url: `/manage/${marinaSlug}/contacts${query}`,
    method: "POST",
    data: contact,
  })
}

export const createContactBoat = async (params) => {
  const marinaSlug = getCurrentMarinaSlug()
  let contactId = params.contactId
  let contact = null
  if (!contactId) {
    contact = await mutateApi({
      url: `/manage/${marinaSlug}/contacts`,
      method: "POST",
      data: params.contact,
    })
    contactId = contact.id
  }
  const boat = await mutateApi({
    url: `/manage/${marinaSlug}/contacts/${contactId}/contact_boats`,
    method: "POST",
    data: params.boat,
  })
  return { contact, boat }
}

export const createContactBoatPhoto = async (
  contactId,
  contactBoatId,
  photo
) => {
  const marinaSlug = getCurrentMarinaSlug()

  const formData = new FormData()
  formData.append("photo", photo)

  return await formPostApi({
    url: `/manage/${marinaSlug}/contacts/${contactId}/contact_boats/${contactBoatId}/contact_boat_photo`,
    data: formData,
  })
}

export const updateContactBoatPhoto = async (
  contactId,
  contactBoatId,
  photo
) => {
  const marinaSlug = getCurrentMarinaSlug()

  const formData = new FormData()
  formData.append("photo", photo)

  const response = await formPutApi({
    url: `/manage/${marinaSlug}/contacts/${contactId}/contact_boats/${contactBoatId}/contact_boat_photo`,
    data: formData,
  })

  return response
}

export const deleteContactBoatPhoto = async (contactId, contactBoatId) => {
  const marinaSlug = getCurrentMarinaSlug()

  return await mutateApi({
    url: `/manage/${marinaSlug}/contacts/${contactId}/contact_boats/${contactBoatId}/contact_boat_photo`,
    method: "DELETE",
  })
}

export const archiveContactBoat = (contactBoatEncodedId) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/contact_boats/${contactBoatEncodedId}/archive`,
    method: "POST",
  })
}

export const restoreContactBoat = (contactBoatEncodedId) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/contact_boats/${contactBoatEncodedId}/restore`,
    method: "POST",
  })
}

export const createContactWithBoat = (
  marinaSlug,
  { contact, contactBoat, extraFields = [] }
) => {
  const query = extraFields.length ? `?include=${extraFields.join(",")}` : ""
  return mutateApi({
    url: `/manage/${marinaSlug}/contacts/create_with_boat${query}`,
    method: "POST",
    data: { contact, contact_boat: contactBoat },
  }).then((response) => response.data)
}

// TODO: Remove filterByMarina once the DataTableV2 migration is fully deployed (BOAT-1690)
export const filterByMarina = ({
  contactBoatSearchQuery,
  page = 1,
  registration,
  insurance,
  boatType,
  loaMin,
  loaMax,
  sortKey,
  sortDirection,
}) => {
  const marinaSlug = getCurrentMarinaSlug()
  return mutateApi({
    url: `/manage/${marinaSlug}/contact_boats/filter_by_marina`,
    method: "POST",
    data: {
      search_query: contactBoatSearchQuery,
      page,
      registration,
      insurance,
      boat_type: boatType,
      loa_min: loaMin,
      loa_max: loaMax,
      sort_key: sortKey ? camelCaseToSnakecase(sortKey) : null,
      sort_direction: sortDirection,
    },
  })
}
